export const SectionHeader = (props) => {
  const badge = props.badge;
  const title = props.title;
  const subtitle = props.subtitle;
  const centered = props.centered !== false;
  const className = props.className || "";

  return (
    <div className={`${centered ? 'text-center' : 'text-left'} ${className}`}>
      {badge && (
        <span className="badge-green mb-4 inline-block" data-testid="section-badge">
          {badge}
        </span>
      )}
      <h2 
        className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4"
        data-testid="section-title"
      >
        {title}
      </h2>
      {subtitle && (
        <p 
          className={`text-lg text-slate-600 ${centered ? 'max-w-2xl mx-auto' : ''}`}
          data-testid="section-subtitle"
        >
          {subtitle}
        </p>
      )}
    </div>
  );
};
